// src/i18n.js
import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// Importing the language JSON files
import enAuth from "./locales/en/auth.json";
import enClients from "./locales/en/clients.json";
import enCommon from "./locales/en/common.json";
import enRequests from "./locales/en/requests.json";
import enResellers from "./locales/en/resellers.json";
import enStocks from "./locales/en/stocks.json";

import enUsers from "./locales/en/users.json";
import enVessels from "./locales/en/vessels.json";
import frAuth from "./locales/fr/auth.json";
import frClients from "./locales/fr/clients.json";
import frCommon from "./locales/fr/common.json";
import frRequests from "./locales/fr/requests.json";
import frResellers from "./locales/fr/resellers.json";
import frStocks from "./locales/fr/stocks.json";
import frUsers from "./locales/fr/users.json";
import frVessels from "./locales/fr/vessels.json";

i18n
	.use(initReactI18next) // Pass i18n instance to react-i18next.
	.init({
		resources: {
			en: {
				auth: enAuth,
				vessels: enVessels,
				common: enCommon,
				users: enUsers,
				clients: enClients,
				requests: enRequests,
				resellers: enResellers,
				stocks: enStocks,
			},
			fr: {
				auth: frAuth,
				vessels: frVessels,
				common: frCommon,
				users: frUsers,
				clients: frClients,
				requests: frRequests,
				resellers: frResellers,
				stocks: frStocks,
			},
		},
		lng: "en", // Default language
		fallbackLng: "en", // Fallback language if translation is missing
		ns: ["auth", "vessels", "users", "requests", "resellers", "stocks", "common"], // Set default namespace
		defaultNS: "auth", // Use "auth" as the default namespace
		interpolation: {
			escapeValue: false, // React already safes from XSS
		},
	});

export default i18n;
